import Tag from '@hilbi/web-common/components/tag';
import { readableColor } from 'polished';
import React from 'react';
import { useIntl } from 'react-intl';
import TagAction from './tag-action/tag-action';

export function useTableColumns() {
  const { formatMessage } = useIntl();

  return React.useMemo(() => {
    return [
      {
        Header: formatMessage({ id: 'tags_name' }),
        accessor: 'name',
        id: 'name',
        disableSortBy: false,
      },
      {
        Header: formatMessage({ id: 'tags_color' }),
        accessor: 'color',
        id: 'color',
        disableSortBy: true,
        Cell: ({ row }: any) => {
          return (
            <div style={{ display: 'inline-flex' }}>
              <Tag
                name={row.values.abbreviation}
                backgroundColor={row.values.color}
                textColor={readableColor(row.values.color)}
              />
            </div>
          );
        },
      },
      {
        Header: formatMessage({ id: 'tags_abbreviation' }),
        accessor: 'abbreviation',
        disableSortBy: true,
      },
      {
        Header: 'Spôsob komunikácie',
        id: 'settings',
        disableSortBy: true,
        Cell: ({ row }: any) => {
          return (
            <>
              {row.original.settings
                .map((s: string) => formatMessage({ id: `tags_${s}` }))
                .join(', ')}
            </>
          );
        },
      },
      {
        disableSortBy: true,
        Header: '',
        accessor: 'name',
        id: 'actions',
        // eslint-disable-next-line react/display-name
        Cell: ({ row }: any) => {
          return <TagAction tag={row.original} />;
        },
      },
    ];
  }, [formatMessage]);
}
